import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      name: 'Input journal (products)',
      fields: {
        id: 'ID',
      },
    }
  }
}